import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { SsoService } from '../services/sso.service';

@Injectable({
  providedIn: 'root'
})
export class DavinciLoggedInGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private ssoService: SsoService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isAuthenticated = await this.authService.isAuthenticatedViaPing();

    if (isAuthenticated) {
      await this.router.navigate(['/settings/account-summary']);
      return false;
    }

    return true;
  }
}
